export default __webpack_public_path__ + "static/media/kiwllt-logo.bc5b68f4.svg";